import React, { useEffect, useState } from "react";
import { Row, Col, Segmented, Spin, Tooltip, Modal, message } from "antd";
import styled from "styled-components";
import { ButtonFilled } from "reusableComponent/UIButtons";
//import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { StyledTable } from "atoms/Table";
import { useHistory } from "react-router-dom";
import {
  useLocation,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import { CALL_API } from "common/API";
import { STATUS_CODE } from "common/Constants";
import { connect } from "react-redux";
import { getUserInfo, getUserList } from "redux/selectors";
import Viewmodal from "../../Appraisals/Viewmodal";
import moment from "moment";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { LoadingOutlined } from "@ant-design/icons";
import axios from "axios";
import user from "../../../assets/employeeinfo.svg";
import { EmployeeInfo } from "../EmployeeInfo";
import dayjs from "dayjs";

export const ViewWrap = styled.div`
  .comment_title {
    font-family: sans-serif;
    font-size: 13px;
    font-weight: 500;
    line-height: 18.23px;
    text-align: left;
    color: #636980;
  }
  .wrapped-header {
    white-space: normal !important;
  }
  .styled-cursor {
    cursor: pointer;
    color: black;
    font-weight: 400;
    font-size: 16px;
  }
  .top-style {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .segment {
    width: 390px;
    border-radius: 8px;
  }
  .span-style {
    color: #636980;
  }
  .title {
    font-weight: 500;
    font-size: 20px;
    color: #1f243b;
    padding-bottom: 10px;
    padding-top: 10px;
  }

  .section-title {
    font-weight: 600;
    font-size: 16px;
    padding-bottom: 10px;
    padding-top: 10px;
  }

  .rows {
    display: flex;
    justify-content: space-between;
  }
  .col-label {
    color: #636980;
  }
  .col-value {
    margin-left: 40px;
    width: 98px;
    height: 18px;
    gap: 0px;
    opacity: 0px;
  }
  .text {
    font-weight: 400;
    font-size: 16px;
    margin-bottom: 30px !important;
  }
`;
const footerStyle = {
  position: "sticky",
  bottom: 0,
  left: 0,
  right: 0,
  backgroundColor: "#fff",
  padding: "10px",
  display: "flex",
  justifyContent: "end",
  boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
  margin: "0px -20px",
};
const SegmentWrap = styled(Segmented)`
  position: sticky;
  top: 40px;
  float: right;
  background-color: #fff;
  z-index: 100;
  border: 1px solid #ffffff;
  color: #636980;
  border-radius: 8px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
  .ant-segmented-item-selected {
    background-color: #c2fae5 !important;
    color: black;
  }
`;
const StyledModal = styled(Modal)`
  .ant-modal-title {
    font-size: 18px;
    font-weight: bold;
  }
  .item-score {
    font-weight: 400;
    font-size: 14px;
    padding: 10px;
    color: black;
  }
  .item-description {
    font-weight: 400;
    font-size: 14px;
    padding: 10px;
    color: black;
  }
`;

const ViewDetails = ({ userList, userInfo }) => {
  const { id } = useParams();
  const [details, setDetails] = useState({});
  const [loading, setLoading] = useState(false);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [isPdfModalOpen, setIsPdfModalOpen] = useState(false);
  const [loader, setLoader] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const handleCancelModal = () => setIsModalVisible(false);
  const showModal = () => setIsModalVisible(true);
  const create = () => {
    history.push({
      pathname: "/performancemanagement",
      state: {
        tabId: "mineappraisal",
        selectedItem: "performance-management",
      },
    });
  };
  const selectedEmployee = userList?.find(
    (item) => item?.userid === details?.appraiseemailid
  );

  const getDetails = async () => {
    setLoading(true);
    const { code, response, performanceContractList } = await CALL_API(
      `appraisal/attendview?contractid=${id}`,
      "get",
      {}
    );
    if (code === STATUS_CODE?.SUCCESS) {
      setDetails(performanceContractList[0]);
      setLoading(false);
    }
  };

  useEffect(() => {
    getDetails();
  }, []);

  const findUser = userList?.find((item) => item?.userid === userInfo?.userid);
  const appraisalInformation = findUser?.appraisalInformation?.filter(
    (val) => val?.appraisal === "Yes"
  );

  const [selectedSegment, setSelectedSegment] = useState(
    appraisalInformation?.[0]?.roletype || null
  );
  const [appraisalIndex, setAppraisalIndex] = useState(1);
  const [completedsegment, setCompletedSegment] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  // Add this state at the top inside Attend component
  const [objectiveModal, setObjectiveModal] = useState({
    open: false,
    objective: null,
    contract: null,
  });
  const [modalLoading, setModalLoading] = useState(false);
  const [loadingnew, setLoadingnew] = useState(false);
  const [viewLoading, setViewLoading] = useState(false);

  const location = useLocation();

  const roletype = location.state?.roletype;
  const data = location.state?.data;

  const getObjectiveModalConfig = (objective) => {
    switch (objective) {
      case "Strategic / Target Objectives":
        return {
          title: "Strategic objectives",
          secondCol:
            "Strategic objectives aligned to Organizational Strategy for the upcoming appraisal period",
        };
      case "Actions expected from previous Appraisal":
        return {
          title: "Rollover Responsibility from Previous Appraisal",
          secondCol:
            "Objectives that Rolled Over from Previous Appraisal Period",
        };
      case "Key responsibilities (from job descriptions)":
        return {
          title: "Objectives from JD for the Current Appraisal Period",
          secondCol:
            "Target objectives aligned to Organizational Strategy for the current appraisal period",
        };
      case "Additional Roles/ Backstopping Roles":
        return {
          title: "Objectives from JD for the Current Appraisal Period",
          secondCol:
            "Target objectives aligned to Organizational Strategy for the Current appraisal period",
        };
      default:
        return {
          title: "",
          secondCol: "",
        };
    }
  };

  // Helper for mapping API data to modal table
  const getObjectiveDataFromContract = (objective, contract) => {
    switch (objective) {
      case "Strategic / Target Objectives":
        return (contract?.startegicobjectives || []).map((item, idx) => ({
          sno: idx + 1,
          main: item.straobjorgstartegy,
          expectedoutcome: item.expectedoutcome,
          targetdate: item.TargetDate,
          weightage: item.Weightage,
        }));
      case "Actions expected from previous Appraisal":
        return (contract?.rolloverresponsibility || []).map((item, idx) => ({
          sno: idx + 1,
          main: item.previousappraisalperiod,
          expectedoutcome: item.expectedoutcome,
          targetdate: item.TargetDate,
          weightage: item.Weightage,
        }));
      case "Additional Roles/ Backstopping Roles":
        return (contract?.upcomingappraisalperiod || []).map((item, idx) => ({
          sno: idx + 1,
          main: item.upcomingappraisalperiod,
          expectedoutcome: item.expectedoutcome,
          targetdate: item.TargetDate,
          weightage: item.Weightage,
        }));
      case "Key responsibilities (from job descriptions)":
        return (contract?.upcomingappraisalperiod || []).map((item, idx) => ({
          sno: idx + 1,
          main: item.upcomingappraisalperiod,
          expectedoutcome: item.expectedoutcome,
          targetdate: item.TargetDate,
          weightage: item.Weightage,
        }));
      default:
        return [];
    }
  };

  const dataSource = [
    {
      key: "1",
      objectives: "Key responsibilities (from job descriptions) ",
      weightage: 20,
      major_achievement: "Build two different products",
      challenges: "Building the team was a bit hard",
      self_score: 25,
    },
    {
      key: "2",
      objectives: "Additional Roles / Backstopping Roles",
      weightage: 15,
      major_achievement: "Build two different products",
      challenges: "Building the team was a bit hard",
      self_score: 25,
    },
    {
      key: "3",
      objectives: "Strategic / Target objectives",
      weightage: 15,
      major_achievement: "Build two different products",
      challenges: "Building the team was a bit hard",
      self_score: 25,
    },
    {
      key: "4",
      objectives: "Actions expected from previous Appraisal",
      weightage: 15,
      major_achievement: "Build two different products",
      challenges: "Building the team was a bit hard",
      self_score: 25,
    },
  ];
  const columns = [
    {
      title: "Objectives",
      dataIndex: "objectives",
      key: "objectives",

      render: (text, record) => {
        return (
          <span
            style={{ color: "#0066FF", cursor: "pointer" }}
            onClick={async () => {
              setModalLoading(true);
              setLoadingnew(true);

              try {
                const roletype = data.roletype;
                const res = await CALL_API(
                  `appraisal/appraiseemine?userid=${userInfo.userid}`,
                  "get"
                );
                if (res?.code === "SUCCESS") {
                  const contractList = Array.isArray(
                    res.performanceContractList
                  )
                    ? res.performanceContractList
                    : [];
                  const contract = contractList.find(
                    (item) =>
                      item.roletype?.trim().toLowerCase() ===
                      roletype?.trim().toLowerCase()
                  );

                  if (contract) {
                    setObjectiveModal({
                      open: true,
                      objective: text,
                      contract,
                    });
                  } else {
                    message.error(
                      `No contract found for this role. roletype searched: "${data.roletype}"`
                    );
                  }
                } else {
                  message.error("Failed to fetch contract data.");
                }
              } catch (error) {
                message.error("Failed to fetch contract data.");
              } finally {
                setModalLoading(false);
                setLoadingnew(false);
              }
            }}
          >
            {text}
          </span>
        );
      },
    },

    {
      title: "What went well/Major achievement",
      dataIndex: "whatwentwellmajorachivement",
      key: "whatwentwellmajorachivement",
      className: "wrapped-header",
      render: (text) => {
        return text || "-";
      },
    },
    {
      title: "What can be improved / Challenges",
      dataIndex: "whatdidnotgowellchallenges",
      key: "whatdidnotgowellchallenges",
      className: "wrapped-header",
      render: (text) => {
        return text || "-";
      },
    },
    {
      title: "Self Score",
      dataIndex: "selfscore",
      key: "selfscore",
      align: "center",
      render: (text) => {
        return text || "-";
      },
    },
  ];

  const columns1 = [
    {
      title: "Objectives",
      dataIndex: "objective",
      key: "objective",
      render: (text) => {
        return text || "-";
      },
    },
    {
      title: "Weightage(%)",
      dataIndex: "weightage",
      key: "weightage",
      align: "center",
      render: (text) => {
        return text || "-";
      },
    },
    {
      title: "What went well/Major achievement",
      dataIndex: "whatwentwellmajorachivement",
      key: "whatwentwellmajorachivement",
      className: "wrapped-header",
      render: (text) => {
        return text || "-";
      },
    },
    {
      title: "What can be improved / Challenges",
      dataIndex: "whatdidnotgowellchallenges",
      key: "whatdidnotgowellchallenges",
      className: "wrapped-header",
      render: (text) => {
        return text || "-";
      },
    },
    {
      title: "Self Score",
      dataIndex: "selfscore",
      key: "selfscore",
      align: "center",
      render: (text) => {
        return text || "-";
      },
    },
  ];
  const [alignValue, setAlignValue] = React.useState("center");
  //const [loading, setLoading] = useState(false);
  const history = useHistory();

  const tab = history.location?.state?.tab;
  const name = history.location?.state?.name;

  const appraisal = () => {
    history.push({
      pathname: "/performancemanagement",
      state: {
        tabId: "mineappraisal", // sets context to Mine tab
        selectedItem: "performance-management", // or whatever tab section
      },
    });
  };

  const handleSegmentChange = (value) => {
    const index = appraisalInformation.findIndex(
      (item) => item.roletype === value
    );

    setSelectedSegment(value);
    setAppraisalIndex(index + 1);
    setCompletedSegment((prev) => {
      if (!prev.includes(index)) {
        return [...prev, index - 1];
      }
      return prev;
    });
  };

  const userAppraisalInfo = userList
    .find((item) => item?.userid === details?.appraiseemailid)
    ?.appraisalInformation?.filter(
      (val) => val?.roletype === details?.appraiseeroletype
    );
  const jobdescriptionid = userAppraisalInfo?.[0]?.jobDescriptionId;
  const jobdescriptionFileName = userAppraisalInfo?.[0]?.jobdescriptionFileName;

  const viewJobDescription = async () => {
    if (!jobdescriptionid || !jobdescriptionFileName) {
      message.warning("User has not created a Job Description.");
      return;
    }
    const token = window.localStorage.getItem("token") || "";
    try {
      setLoader(true);
      const response = await axios.get(
        "https://axcxv4d066.execute-api.ap-south-1.amazonaws.com/Prod/appraisal/getdocument",
        {
          params: {
            jobdescriptionid: jobdescriptionid,
            filename: jobdescriptionFileName,
          },
          headers: { Insytsjwt: token },
        }
      );
      if (response?.data?.status === "SUCCESS" && response?.data?.url) {
        setPdfUrl(response.data.url);
        setIsPdfModalOpen(true);
      } else {
        message.error(response?.data?.message || "Failed to fetch document.");
        setLoader(false);
      }
    } catch (error) {
      message.error(error?.message || "Failed to fetch document.");
      setLoader(false);
    } finally {
      setLoader(false);
    }
  };

  const handleViewJobDescription = (userList) => {
    if (!Array.isArray(userList)) {
      message.error("Invalid user data.");
      return;
    }
    viewJobDescription();
  };

  const modalTableData = getObjectiveDataFromContract(
    objectiveModal.objective,
    objectiveModal.contract
  );
  return (
    <>
      <Modal
        open={isPdfModalOpen}
        onCancel={() => setIsPdfModalOpen(false)}
        footer={null}
        width={1000}
        centered
        bodyStyle={{ height: "80vh", padding: 0 }}
      >
        {pdfUrl ? (
          <iframe
            src={pdfUrl}
            title="PDF Preview"
            width="100%"
            height="100%"
            style={{ border: "none" }}
          />
        ) : (
          <p style={{ textAlign: "center", paddingTop: "40%" }}>Loading...</p>
        )}
      </Modal>
      <StyledModal
        title={
          <div style={{ display: "flex", alignItems: "center" }}>
            <span style={{ flex: 1 }}>
              {getObjectiveModalConfig(objectiveModal.objective).title}
            </span>
            <span style={{ marginRight: 24 }}>
              <a
                onClick={() => {
                  handleViewJobDescription(userList);
                }}
                style={{
                  cursor: "pointer",
                  fontSize: "16px",
                  color: "#1890ff",
                  fontWeight: "500",
                  textDecoration: "underline",
                }}
              >
                {viewLoading || loader ? (
                  <LoadingOutlined />
                ) : (
                  "Job Description"
                )}
              </a>
            </span>
          </div>
        }
        open={objectiveModal.open}
        footer={null}
        onCancel={() =>
          setObjectiveModal({ open: false, objective: null, contract: null })
        }
        width={1000}
        borderRadius="8px"
      >
        <Spin spinning={modalLoading} size="large">
          {!modalLoading && (
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr>
                  <th style={{ border: "1px solid #eee", padding: 8 }}>S.No</th>
                  <th style={{ border: "1px solid #eee", padding: 8 }}>
                    {
                      getObjectiveModalConfig(objectiveModal.objective)
                        .secondCol
                    }
                  </th>
                  <th style={{ border: "1px solid #eee", padding: 8 }}>
                    Expected Outcome
                  </th>
                  <th
                    style={{
                      width: "15%",
                      border: "1px solid #eee",
                      padding: 8,
                    }}
                  >
                    Target Date
                  </th>
                  <th style={{ border: "1px solid #eee", padding: 8 }}>
                    Weightage
                  </th>
                </tr>
              </thead>
              <tbody>
                {modalTableData.length > 0 ? (
                  modalTableData.map((row, idx) => (
                    <tr key={idx}>
                      <td style={{ border: "1px solid #eee", padding: 8 }}>
                        {row.sno}
                      </td>
                      <td style={{ border: "1px solid #eee", padding: 8 }}>
                        {row.main}
                      </td>
                      <td style={{ border: "1px solid #eee", padding: 8 }}>
                        {row.expectedoutcome}
                      </td>
                      <td
                        style={{
                          width: "15%",
                          border: "1px solid #eee",
                          padding: 8,
                        }}
                      >
                        {row.targetdate
                          ? dayjs(row.targetdate, "YYYY-MM-DD").format(
                              "Do MMM YYYY"
                            )
                          : "-"}
                      </td>
                      <td style={{ border: "1px solid #eee", padding: 8 }}>
                        {row.weightage}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={5} style={{ textAlign: "center", padding: 8 }}>
                      No data available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </Spin>
      </StyledModal>

      <ViewWrap>
        <Spin spinning={loading}>
          <div className="top-style">
            <div className=" styled-cursor">
              <p>
                <span onClick={appraisal} className="span-style">
                  Performance Management &gt;
                </span>{" "}
                <span style={{ cursor: "auto" }}>
                  {data?.roletype} Appraisal
                </span>
              </p>
            </div>
          </div>
          <div className="title">{details?.appraiseeroletype}</div>
          <br />

          {/* Individual Assessment Section */}
          {Object.keys(details).length ? (
            <>
              {/* <div className="section-title">Individual Assessment</div>

              <Row gutter={12}>
                <Col xs={24} md={12}>
                  <div className="rows pt-2 pb-2">
                    <div className="col-label">Client Survey Average Score</div>
                    <div className="col-value">
                      {" "}
                      {details?.individualassessment[0]?.clientsurveyscore ||
                        "-"}
                    </div>
                  </div>
                  <div className="rows pt-2 pb-2">
                    <div className="col-label">VTP Appraisal Average Score</div>
                    <div className="col-value">
                      {" "}
                      {details?.individualassessment[0]?.vtpappraisalscore}
                    </div>
                  </div>
                  <div className="rows pt-2 pb-2">
                    <div className="col-label">
                      LMS – 40 hrs (target to actual %)
                    </div>
                    <div className="col-value">
                      {" "}
                      {details?.individualassessment[0]?.lmstarget}
                    </div>
                  </div>
                  <div className="rows pt-2 pb-2">
                    <div className="col-label">Non–Chargeable %</div>
                    <div className="col-value">
                      {details?.individualassessment[0]?.nonchargeable || "-"}
                    </div>
                  </div>
                  <div className="rows pt-2 pb-2">
                    <div className="col-label">No. of Credentials Inputted</div>
                    <div className="col-value">
                      {details?.individualassessment[0]
                        ?.noofcredentialsinputted || "-"}
                    </div>
                  </div>
                  <div className="rows pt-2 pb-2">
                    <div className="col-label">
                      Avg Time-sheet approval delays in days
                    </div>
                    <div className="col-value">
                      {details?.individualassessment[0]
                        ?.avgtimesheetapprovedelaydays || "-"}
                    </div>
                  </div>
                  <div className="rows pt-2 pb-2">
                    <div className="col-label">
                      No. of assignments worked on
                    </div>
                    <div className="col-value">
                      {details?.individualassessment[0]
                        ?.noofassignmentsworked || "-"}
                    </div>
                  </div>

                  <div className="rows pt-2 pb-2">
                    <div className="col-label">Employee Profit/Loss</div>
                    <div className="col-value">
                      {details?.individualassessment[0]?.employeeprofitloss ||
                        "-"}
                    </div>
                  </div>
                  <div className="rows pt-2 pb-2">
                    <div className="col-label">No.of leads Created</div>
                    <div className="col-value">
                      {details?.individualassessment[0]?.noofleads || "-"}
                    </div>
                  </div>
                </Col>
                <Col xs={24} md={12}>
                  <div className="rows pt-2 pb-2">
                    <div className="col-label">
                      Engagement Appraisal Average Score
                    </div>
                    <div className="col-value">
                      {" "}
                      {details?.individualassessment[0]
                        ?.engagementappraisalscore || "-"}
                    </div>
                  </div>
                  <div className="rows pt-2 pb-2">
                    <div className="col-label">Leaves Taken (Days)</div>
                    <div className="col-value">
                      {" "}
                      {details?.individualassessment[0]?.leavetakendays || "-"}
                    </div>
                  </div>
                  <div className="rows pt-2 pb-2">
                    <div className="col-label">
                      Chargeability (Target to Actual %)
                    </div>
                    <div className="col-value">
                      {details?.individualassessment[0]?.chargeability || "-"}
                    </div>
                  </div>
                  <div className="rows pt-2 pb-2">
                    <div className="col-label">CV Last Updated (Date)</div>
                    <div className="col-value">
                      {details?.individualassessment[0]?.cvlastupdateddate
                        ? moment(
                            details?.individualassessment[0]?.cvlastupdateddate
                          ).format("Do MMM YYYY")
                        : "-"}
                    </div>
                  </div>
                  <div className="rows pt-2 pb-2">
                    <div className="col-label">
                      Avg Time-sheet delays in days
                    </div>
                    <div className="col-value">
                      {details?.individualassessment[0]
                        ?.avgtimesheetdelaydays || "-"}
                    </div>
                  </div>
                  <div className="rows pt-2 pb-2">
                    <div className="col-label">
                      Average Task Delays in Days (VTP)
                    </div>
                    <div className="col-value">
                      {details?.individualassessment[0]?.avgtaskdelaydays ||
                        "-"}
                    </div>
                  </div>
                  <div className="rows pt-2 pb-2">
                    <div className="col-label">Employee Billing</div>
                    <div className="col-value">
                      {details?.individualassessment[0]?.employeebilling || "-"}
                    </div>
                  </div>
                  <div className="rows pt-2 pb-2">
                    <div className="col-label">
                      Amounts of Proposal in the pipeline
                    </div>
                    <div className="col-value">
                      $
                      {details?.individualassessment[0]?.amountsofproposal ||
                        "-"}
                    </div>
                  </div>
                  <div className="rows pt-2 pb-2">
                    <div className="col-label">
                      Proposal Conversion Rates(%)
                    </div>
                    <div className="col-value">
                      {details?.individualassessment[0]
                        ?.proposalconversionrate || "-"}
                    </div>
                  </div>
                </Col>
              </Row>
              <br />
              <br /> */}
              {/* <div className="section-title">
                Departmental/Country/Cluster level assessment
              </div> */}
              <Row gutter={12}>
                <Col xs={24} md={24}>
                  <h6>
                    Employee Scorecard - Power BI -{" "}
                    <a
                      href="https://app.powerbi.com/groups/630f8390-9880-4177-929b-7bd91f0bedfe/reports/3d76a0ac-948e-454b-bf3b-75e04b2d3f5c/d45f4930a7bc58596021?experience=power-bi"
                      id="m_-8402443038962109074m_-6895529901520386798OWAb5b7a0de-4f34-011d-612c-0f428cd224db"
                      target="_blank"
                      data-saferedirecturl="https://www.google.com/url?q=https://app.powerbi.com/groups/630f8390-9880-4177-929b-7bd91f0bedfe/reports/3d76a0ac-948e-454b-bf3b-75e04b2d3f5c/d45f4930a7bc58596021?experience%3Dpower-bi&amp;source=gmail&amp;ust=1751024712172000&amp;usg=AOvVaw3TFhX25zyjt-Ip9o8oqWYh"
                    >
                      Employee Scorecard - Power BI
                    </a>
                  </h6>
                  {/* <div className="rows pt-2 pb-2">
                    <div className="col-label">
                      Revenue, Rev vs budget, and GOLY%
                    </div>
                    <div className="col-value">
                      {details?.clusterlevel[0]?.revenue || "-"}
                    </div>
                  </div>
                  <div className="rows pt-2 pb-2">
                    <div className="col-label">Rev/ Profit per employee</div>
                    <div className="col-value">
                      {details?.clusterlevel[0]?.employeeprofit || "-"}
                    </div>
                  </div>

                  <div className="rows pt-2 pb-2">
                    <div className="col-label">Debtors in USD and days</div>
                    <div className="col-value">
                      {details?.clusterlevel[0]?.debtors || "-"}
                    </div>
                  </div> */}
                </Col>

                {/* <Col xs={24} md={12}>
                  <div className="rows pt-2 pb-2">
                    <div className="col-label">
                      Departmental Profit, vs budget, GOLY %
                    </div>
                    <div className="col-value">
                      {details?.clusterlevel[0]?.departmentprofit || "-"}
                    </div>
                  </div>
                  <div className="rows pt-2 pb-2">
                    <div className="col-label">
                      Employee cost, Profits as a %age of rev
                    </div>
                    <div className="col-value">
                      {details?.clusterlevel[0]?.employeecost || "-"}
                    </div>
                  </div>
                </Col> */}
              </Row>
              <br />
              <br />
              <div className="section-title">Technical Assessment</div>
              <StyledTable
                columns={columns}
                dataSource={details?.technicalassessment || []}
                className="custom-table"
                size="middle"
                pagination={false}
                //loading={loading}
              />
              <br />
              <br />
              {details?.appraiseeroletype === "Primary" && (
                <>
                  <div className="section-title">
                    Individual (Soft Skills) Assessment / BDO Values
                  </div>
                  <StyledTable
                    columns={columns1}
                    dataSource={details?.softskills || []}
                    className="custom-table"
                    size="middle"
                    pagination={false}
                    //loading={loading}
                  />
                  <br />
                </>
              )}

              <br />
              {details?.appraiseeroletype === "Primary" && (
                <>
                  <div className="section-title">Succession Planning</div>
                  <Row
                    gutter={16}
                    style={{
                      background: "#E4E4E4",
                      marginBottom: "10px",
                      borderRadius: "5px",
                      padding: "5px",
                    }}
                  >
                    <Col xs={24} md={12} className="mb-2">
                      <p>Who am I mentoring for my role?</p>
                    </Col>
                    <Col xs={24} md={12}>
                      <Row gutter={(16, 16)}>
                        <Col xs={24} md={6}>
                          <label className="comment_title">People</label>
                        </Col>
                        <Col
                          xs={24}
                          md={18}
                          style={{ whiteSpace: "wrap", wordWrap: "break-word" }}
                        >
                          {details?.successionplanning?.[0]?.mentoringrole !==
                          "none"
                            ? userList
                                ?.filter((val) =>
                                  details?.successionplanning?.[0]?.succeedperson?.includes(
                                    val?.userid
                                  )
                                )
                                ?.map((item) => item?.fullname)
                                ?.join(", ") || "-"
                            : "none"}
                        </Col>
                        {details?.successionplanning?.[0]?.mentoringrole !==
                          "none" && (
                          <>
                            <Col xs={24} md={6} className="mt-2">
                              <label className="comment_title">Remark</label>
                            </Col>
                            <Col
                              xs={24}
                              md={18}
                              className="mt-2"
                              style={{
                                whiteSpace: "wrap",
                                wordWrap: "break-word",
                              }}
                            >
                              {
                                details?.successionplanning?.[0]
                                  ?.succeedpersonremark
                              }
                            </Col>
                          </>
                        )}
                      </Row>
                    </Col>
                  </Row>
                  <Row
                    gutter={16}
                    style={{
                      background: "#E4E4E4",
                      marginBottom: "30px",
                      borderRadius: "5px",
                      padding: "5px",
                    }}
                  >
                    <Col xs={24} md={12} className="mb-2">
                      <p> Who is mentoring me for my next role?</p>
                    </Col>
                    <Col xs={24} md={12}>
                      <Row gutter={(16, 16)}>
                        <Col xs={24} md={6}>
                          <label className="comment_title">People</label>
                        </Col>
                        <Col xs={24} md={18}>
                          {details?.successionplanning?.[0]
                            ?.mentoringnextrole !== "none"
                            ? userList
                                ?.filter((val) =>
                                  details?.successionplanning?.[0]?.succeedpersonnext?.includes(
                                    val?.userid
                                  )
                                )
                                ?.map((item) => item?.fullname)
                                ?.join(", ") || "-"
                            : "none"}
                        </Col>
                        {details?.successionplanning?.[0]?.mentoringnextrole !==
                          "none" && (
                          <>
                            <Col xs={24} md={6}>
                              <label className="comment_title">Remark</label>
                            </Col>
                            <Col xs={24} md={18}>
                              {
                                details?.successionplanning?.[0]
                                  ?.succeedpersonremarknext
                              }
                            </Col>
                          </>
                        )}
                      </Row>
                    </Col>
                  </Row>
                </>
              )}
              <div className="section-title">Overall Summary</div>
              <br />
              <p className="text" style={{ marginTop: "-20px" }}>
                {details?.individualassessment?.[0]?.overallsummary || "-"}
              </p>
              <br />
              <br />
            </>
          ) : null}
          <div style={footerStyle}>
            <ButtonFilled
              style={{ marginRight: "40px", width: "130px" }}
              onClick={create}
            >
              Back
            </ButtonFilled>
          </div>
        </Spin>
      </ViewWrap>
      <img
        src={user}
        alt="Floating User Icon"
        style={{
          position: "fixed",
          bottom: "50px",
          right: "50px",
          width: "100px",
          height: "100px",
          borderRadius: "50%",
          zIndex: 1000,
          cursor: "pointer",
        }}
        onClick={showModal}
      />
      <EmployeeInfo
        isModalVisible={isModalVisible}
        handleCancelModal={handleCancelModal}
        selectedEmployee={selectedEmployee}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  userInfo: getUserInfo(state),
  userList: getUserList(state),
});

export default connect(mapStateToProps)(ViewDetails);
